export default function errorSecurity(state={}, action) {
	switch (action.type) {
		case 'SET_ERROR_SECURITY':
			return {
				...state,
				title: action.data.title,
				message: action.data.message
			};
		default:
			break;
	}
	return state;
}


// WEBPACK FOOTER //
// ./app/reducers/errorSecurity.js